import commonPt from "../locales/pt/common.json";
import landingPt from "../locales/pt/landing.json";
import accountPt from "../locales/pt/account.json";
import foruPt from "../locales/pt/foru.json";
import forujobPt from "../locales/pt/forujob.json";
import garantiasPt from "../locales/pt/garantias.json";
import formsPt from "../locales/pt/forms.json";
import legalSecurityCiberPt from "../locales/pt/legalSecurityCiber.json";
import legalSecurityDadosPt from "../locales/pt/legalSecurityDados.json";
import legalSecurityUsesPt from "../locales/pt/legalSecurityUses.json";
import legalOuvidoriaPt from "../locales/pt/legalOuvidoria.json";
import legalAccountCancellationPt from "../locales/pt/legalAccountCancellation.json";
import legalContratoPFPt from "../locales/pt/legalContratoPF.json";
import legalContratoPJPt from "../locales/pt/legalContratoPJ.json";
import legalGarantiasPt from "../locales/pt/legalGarantias.json";

import commonEn from "../locales/en/common.json";
import landingEn from "../locales/en/landing.json";
import accountEn from "../locales/en/account.json";
import foruEn from "../locales/en/foru.json";
import forujobEn from "../locales/en/forujob.json";
import garantiasEn from "../locales/en/garantias.json";
import formsEn from "../locales/en/forms.json";
import legalSecurityCiberEn from "../locales/en/legalSecurityCiber.json";
import legalSecurityDadosEn from "../locales/en/legalSecurityDados.json";
import legalSecurityUsesEn from "../locales/en/legalSecurityUses.json";
import legalOuvidoriaEn from "../locales/en/legalOuvidoria.json";
import legalAccountCancellationEn from "../locales/en/legalAccountCancellation.json";
import legalContratoPFEn from "../locales/en/legalContratoPF.json";
import legalContratoPJEn from "../locales/en/legalContratoPJ.json";
import legalGarantiasEn from "../locales/en/legalGarantias.json";

import commonEs from "../locales/es/common.json";
import landingEs from "../locales/es/landing.json";
import accountEs from "../locales/es/account.json";
import foruEs from "../locales/es/foru.json";
import forujobEs from "../locales/es/forujob.json";
import garantiasEs from "../locales/es/garantias.json";
import formsEs from "../locales/es/forms.json";
import legalSecurityCiberEs from "../locales/es/legalSecurityCiber.json";
import legalSecurityDadosEs from "../locales/es/legalSecurityDados.json";
import legalSecurityUsesEs from "../locales/es/legalSecurityUses.json";
import legalOuvidoriaEs from "../locales/es/legalOuvidoria.json";
import legalAccountCancellationEs from "../locales/es/legalAccountCancellation.json";
import legalContratoPFEs from "../locales/es/legalContratoPF.json";
import legalContratoPJEs from "../locales/es/legalContratoPJ.json";
import legalGarantiasEs from "../locales/es/legalGarantias.json";

export const resources = {
  pt: {
    common: commonPt,
    landing: landingPt,
    account: accountPt,
    foru: foruPt,
    forujob: forujobPt,
    garantias: garantiasPt,
    forms: formsPt,
    legalSecurityCiber: legalSecurityCiberPt,
    legalSecurityDados: legalSecurityDadosPt,
    legalSecurityUses: legalSecurityUsesPt,
    legalOuvidoria: legalOuvidoriaPt,
    legalAccountCancellation: legalAccountCancellationPt,
    legalContratoPF: legalContratoPFPt,
    legalContratoPJ: legalContratoPJPt,
    legalGarantias: legalGarantiasPt,
  },
  en: {
    common: commonEn,
    landing: landingEn,
    account: accountEn,
    foru: foruEn,
    forujob: forujobEn,
    garantias: garantiasEn,
    forms: formsEn,
    legalSecurityCiber: legalSecurityCiberEn,
    legalSecurityDados: legalSecurityDadosEn,
    legalSecurityUses: legalSecurityUsesEn,
    legalOuvidoria: legalOuvidoriaEn,
    legalAccountCancellation: legalAccountCancellationEn,
    legalContratoPF: legalContratoPFEn,
    legalContratoPJ: legalContratoPJEn,
    legalGarantias: legalGarantiasEn,
  },
  es: {
    common: commonEs,
    landing: landingEs,
    account: accountEs,
    foru: foruEs,
    forujob: forujobEs,
    garantias: garantiasEs,
    forms: formsEs,
    legalSecurityCiber: legalSecurityCiberEs,
    legalSecurityDados: legalSecurityDadosEs,
    legalSecurityUses: legalSecurityUsesEs,
    legalOuvidoria: legalOuvidoriaEs,
    legalAccountCancellation: legalAccountCancellationEs,
    legalContratoPF: legalContratoPFEs,
    legalContratoPJ: legalContratoPJEs,
    legalGarantias: legalGarantiasEs,
  },
};
